import { Typography, Grid } from "@mui/material";
import CustomSelect from "../shared/CustomSelect";

const SectionHeader = ({ headline }) => {
  return (
    <Grid
      container
      justifyContent="space-between"
      sx={{ marginBottom: "20px" }}
    >
      <Grid item>
        <Typography
          sx={{
            color: "#050D2E",
            fontSize: "1.125rem",
            fontWeight: 550,
            lineHeight: "21px",
          }}
        >
          {headline}
        </Typography>
      </Grid>
      <Grid item>
        <Grid container spacing={1}>
          <Grid item>
            <CustomSelect
              options={[
                {
                  id: "date",
                  value: "Date",
                  label: "Date",
                },
              ]}
              fieldName="Sort By"
              groupBy="Sort"
              width={90}
              selectedValue={{
                id: "date",
                value: "Date",
                label: "Date",
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SectionHeader;
